import { constants } from "@reactivated/constants";

export const DesignVersion =
    constants["server.cms.models.pages.design_version.DesignVersion"];

export type DesignVersion = (typeof DesignVersion)[keyof typeof DesignVersion];

/**
 * Only pages with a `design_version` field can opt into a newer design.
 * Everything else (other page types, error pages) renders the 2024 design.
 */
export const resolveDesignVersion = (
    value: string | null | undefined,
): DesignVersion =>
    value === DesignVersion.V2026 ? DesignVersion.V2026 : DesignVersion.V2024;
